import React from 'react'

const PageSmallParagraph = ({ slice }) => {
    return (
        <section className="page-small-paragraph">
            <div className="center-small">
                {slice.items.map((item, index) => (
                    <p className="small-paragraph">{item.text.text}</p>
                ))}
            </div>
        </section>
    )
}

export default PageSmallParagraph